// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"1662aedf","31":"99a1890b","104":"9b604bed","115":"34cc700a","195":"212f3fd7","335":"0514fb0c","383":"ac34d14c","589":"82aa1254","634":"3fadee92","729":"1b643ef1","734":"b17b5647","812":"d2817034","908":"53d81d8b","981":"aefb6410"}[chunkId] + ".chunk.js";
};